import { ApiClient } from "@ucl/library";
import { AppUser } from "../contexts/UserContext/types";

class ApplicationUserApiClient {
  private _apiClient: ApiClient;

  constructor(apiClient: ApiClient) {
    this._apiClient = apiClient;
  }

  /**
   * Login for consumer users
   */
  loginConsumer = async (accessToken: string): Promise<AppUser> => {
    return this._apiClient.post<AppUser>(
      `api/application-user/consumer/login`,
      {},
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
  };

  /**
   * Login for banker users
   */
  loginBanker = async (accessToken: string): Promise<AppUser> => {
    return this._apiClient.post<AppUser>(
      `api/application-user/banker/login`,
      {},
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
  };

  /**
   * Check permission for a specific user
   */
  checkPermission = async (
    userId: string,
    actionName: string,
    resourceName: string | undefined,
    accessToken: string
  ): Promise<boolean> => {
    const params = new URLSearchParams({
      userId,
      actionName,
      ...(resourceName && { resourceName }),
    });

    return this._apiClient.get<boolean>(`api/application-user/permissions/check?${params}`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  };

  /**
   * Check multiple permissions for a specific user
   */
  checkPermissions = async (
    userId: string,
    requiredPermissions: {
      actionName: string;
      resourceName?: string;
    }[],
    accessToken: string
  ): Promise<
    {
      actionName: string;
      resourceName?: string;
      hasPermission: boolean;
    }[]
  > => {
    return this._apiClient.post<
      {
        actionName: string;
        resourceName?: string;
        hasPermission: boolean;
      }[]
    >(
      `api/application-user/permissions/check-multiple`,
      {
        userId,
        requiredPermissions,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
  };
}

export default ApplicationUserApiClient;
